import { alertRequest, body } from "services/request";

const baseUrl = "api/LogisticSalary";

const apply = (params: {}) => alertRequest(`${baseUrl}/apply`, body(params));

export { apply };
